<div class="modal-container-custom">
  <div class="modal-content-custom dataStyle_1">
    <div class="modal-header">
      <button type="button" id="close-doc-additional-data-modal" class="close" aria-label="Close"
        (click)="activeModal.close()">
        <span aria-hidden="true">&times;</span>
      </button>
      <h4 class="modal-title enabled-text">{{documentNameMap[docKey]}}</h4>
    </div>
    <form autocomplete="off" [formGroup]="docDateForm" *ngIf="docDateForm">
      <div class="modal-body">
        <small>Please provide the required details and Proceed to generate the document.</small>
        <div class="dark-section">
          <div class="row my-6">
            <div class="offset-1 col-10 py-4">
                <div class="compt-input p-3 mt-2 mb-4">
                <label>Date</label>
                <div class="r-value-box">
                  <input [attr.value]="docDateForm.get('document_date').value" id="document-date"
                    class="form-control block-box text-left pt-5" [outsideDays]="'collapsed'"
                    placeholder="Document Date" name="document-date" formControlName="document_date"
                    [minDate]="looDateObj" [maxDate]="issueValueDateObj" [markDisabled]="isWeekendAndHolidayDisabled"
                    ngbDatepicker #documentDate="ngbDatepicker" (click)="documentDate.toggle()" [readonly]="true" required>
                  <div class="input-group-append icons-calender">
                    <button class="btn" (click)="documentDate.toggle()" type="button" id="document-date-btn">
                      <i class="far-i fa fa-calendar"></i>
                    </button>
                  </div>
                </div>
                <div class="error-text" *ngIf="docDateForm.get('document_date').errors">
                  <small *ngIf="docDateForm.get('document_date').errors.ngbDate">
                    <ng-container *ngIf="docDateForm.get('document_date').errors.ngbDate.requiredBefore">
                      Date should be more than or equal to Letter Of Offer date : {{looDateFormatted}}.
                    </ng-container>
                    <ng-container *ngIf="docDateForm.get('document_date').errors.ngbDate.requiredAfter">
                      Date should be less than or equal to Issue Value Date : {{issueValueDateFormatted}}.
                    </ng-container>
                  </small>
                  <small *ngIf="docDateForm.get('document_date').errors.required">
                    Date is required for document generation.
                  </small>
                </div>
              </div>
              <br/><br/>
              <div>
                <div class="row bottom-margin-20 profile-details-white-border"></div>
                <h6 class="dataStyle_2">The Below Fields Are Applicable for NBFC or HFC issuer Only</h6>

              <small>Please download Residual Maturity Profile doc below and fill the details.</small><br/>
                <button class="btn btn-md text-left btn-outline-normal mr-6 py-2 cpheldStyle_1" (click)="downloadAddExcel()">Download</button><br/>
                <small class="info-text small-text ml-6">
                  <i>
                    Note: Fill the yellow fields only. Do not edit anything else in the sheet.
                  </i>
                </small><br/>
                
                <div class="compt-input">
                  <label for="uploadExcelAddData">Upload Additional Data File (Excel)</label>
                  <app-upload-button id="upload-excel" #uploadExcelAddData
                    componentId="uploadExcel" [cssOverrideClass]="'upload-resize-height'"
                    [uploadType]="'KEY'" [fileTypes]="fileTypes"
                    (fileAsDataURL)="uploadDocument($event, 'Residual Maturity Profile Excel','CREATE')">
                  </app-upload-button>
                  <small>
                    {{uploadExcelAddData.fileName}}
                  </small>
                  <br/>
                <small class="info-text small-text ml-6">
                <button class="btn btn-md text-left btn-outline-normal mr-6 py-2 cpheldStyle_1" (click)="deleteMaturityData('DELETE')">Delete Existing Residual Maturity Profile Details</button><br/>
              </small>
            </div>
            
              </div>
          </div>
        </div>
      </div>
      <small class="info-text small-text ml-6">
        <i>
          Note: Ensure all the Related and Applicable Details are present in the admin before generating this document.
        </i>
      </small><br/>
    </div>
    </form>
    <div class="modal-footer modal-footer-custom">
      <button type="button" id="cancel-doc-additional-data-modal"
        class="col-md-4 btn btn-outline-normal btn-style-right-1 text-left"
        (click)="activeModal.close()">Cancel</button>
      <button type="submit" id="generate-doc-additional-data"
        class="col-md-4 btn btn-md btn-style-right-1 btn-success text-left for-icon-right for-right-arrow"
        (click)="postDocDateAdditionalData(docDateForm.value)">Generate</button>
    </div>
  </div>
</div>